<template>
  <div>
    <!-- {{ temInstrumentoPadrao }} -->
    <div class="mt-6 d-flex align-center justify-space-between">
      <div style="width: 50rem" @click="confirmacaoEditarInstrumentoPadrao">
        <input-text :value="instrumentoPadraoAtual" readonly>
          <template #prepend-inner>
            <div class="mt-1 primary-grey-600--text">
              {{ $t('modulos.calibracao.valores.instrumento_padrao') }}:
            </div>
          </template>
        </input-text>
      </div>
      <div v-if="!podeEditar || visualizar">
        <botao-padrao
          class="ml-2"
          color="secondary"
          :tooltip="
            $t('modulos.calibracao.valores.botoes.tooltip.visualizar_historico')
          "
          outlined
          :disabled="!ultimaCalibracaoId"
          @click="abrirVisualizarDadosHistorico"
        >
          <v-icon> $fileSearchOutline </v-icon>1
        </botao-padrao>
      </div>
      <div v-else-if="podeEditar" class="d-flex align-center">
        <botao-padrao
          v-if="0"
          class="mr-2"
          color="secondary"
          outlined
          :disabled="flagImportacaoDados"
        >
          <button @click="exibirImportacao()">Exibir Importação</button>
        </botao-padrao>

        <ImportacaoDados
          v-if="0"
          class="mr-2"
          :flag-importacao-dados="flagImportacaoDados"
          :calibracao-id="calibracaoId"
        />

        <botao-padrao
          class="mr-2"
          color="secondary"
          outlined
          @click="anexarArquivo"
        >
          <v-icon> $paperclipPlus </v-icon>
        </botao-padrao>

        <botao-padrao
          v-if="!statusOCR && utilizaOcr"
          class="mr-2"
          color="secondary"
          outlined
          @click="iniciarCapturaOCR"
        >
          <v-icon class="mr-2"> $playCircle </v-icon>
          {{ $t('modulos.calibracao.valores.botoes.iniciar_ocr') }}
        </botao-padrao>
        <botao-padrao
          v-if="statusOCR"
          class="mr-2"
          color="red"
          outlined
          @click="interrromperCapturaOCR"
        >
          <v-icon class="mr-2"> $stopCircle </v-icon>
          {{ $t('modulos.calibracao.valores.botoes.parar_ocr') }}
        </botao-padrao>
        <botao-padrao
          v-if="!statusCloudVision && !utilizaOcr"
          class="mr-2"
          color="secondary"
          outlined
          @click="iniciarCapturaCloudVision"
        >
          <v-icon class="mr-2"> $playCircle </v-icon>
          {{ $t('modulos.calibracao.valores.botoes.iniciar_cloud_vision') }}
        </botao-padrao>
        <botao-padrao
          v-if="statusCloudVision"
          class="mr-2"
          color="red"
          outlined
          @click="interrromperCapturaCloudVision"
        >
          <v-icon class="mr-2"> $stopCircle </v-icon>
          {{ $t('modulos.calibracao.valores.botoes.parar_cloud_vision') }}
        </botao-padrao>
        <dropdown-padrao
          :tooltip="$t('modulos.calibracao.valores.botoes.tooltip.weight')"
          seta
          color="secondary"
          outlined
        >
          <template #botao>
            <v-icon>$weight</v-icon>
          </template>
          <dropdown-padrao-item
            :disabled="!temSMP"
            @click="confirmacaoEditarInstrumentoPadrao"
          >
            {{ $t('modulos.calibracao.valores.botoes.editar') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item
            :disabled="!tabelaValoresAtual.instrumentosAlterados"
            @click="confirmarLimparInstrumentoPadrao"
          >
            {{ $t('modulos.calibracao.valores.botoes.limpar') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item
            :disabled="!temSMP"
            @click="confirmacaoLimparSMP"
          >
            {{ $t('modulos.calibracao.valores.botoes.limpar_smp') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item
            :disabled="!temSMC"
            @click="confirmacaoLimparSMC"
          >
            {{ $t('modulos.calibracao.valores.botoes.limpar_smc') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item
            :disabled="!temSMP"
            @click="copiarColuna('SMP')"
          >
            {{ $t('modulos.calibracao.valores.botoes.copiar_smp') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item
            :disabled="!temSMC"
            @click="copiarColuna('SMC')"
          >
            {{ $t('modulos.calibracao.valores.botoes.copiar_smc') }}
          </dropdown-padrao-item>
          <dropdown-padrao-item @click="copiarHistorico()">
            {{ $t('modulos.calibracao.valores.botoes.copiar_historico') }}
          </dropdown-padrao-item>
        </dropdown-padrao>
        <botao-padrao
          class="ml-2"
          color="secondary"
          :tooltip="
            $t('modulos.calibracao.valores.botoes.tooltip.conversor_unidades')
          "
          outlined
          @click="abrirParaConversorDeUnidadeDeMedida"
        >
          <v-icon> $calculatorVariantOutline </v-icon>
        </botao-padrao>
        <botao-padrao
          v-if="temComunicacaoInstrumento"
          class="ml-2"
          color="secondary"
          :tooltip="tooltipComunicacaoInstrumento"
          outlined
          @click="conectar"
        >
          <v-icon> $mdiAbacus </v-icon>
        </botao-padrao>
        <botao-padrao
          class="ml-2"
          color="secondary"
          :tooltip="
            $t('modulos.calibracao.valores.botoes.tooltip.visualizar_historico')
          "
          outlined
          :disabled="!ultimaCalibracaoId"
          @click="abrirVisualizarDadosHistorico"
        >
          <v-icon> $fileSearchOutline </v-icon>
        </botao-padrao>
        <botao-padrao
          class="ml-2"
          :tooltip="$t('modulos.calibracao.valores.botoes.tooltip.instrumento')"
          color="secondary"
          outlined
          @click="abrirEdicaoDoInstrumento"
        >
          <v-icon> $rulerSquareCompass </v-icon>
        </botao-padrao>
      </div>
    </div>
    <v-form :readonly="!podeEditar || visualizar">
      <v-simple-table
        :key="keyTabelaValores"
        dense
        class="mt-3 tabela-dinamica-calibracao"
      >
        <thead>
          <tr>
            <th scope="rol" class="coluna-propriedades">
              {{ $t('modulos.calibracao.valores.cabecalho') }}
            </th>
            <th scope="rol" class="coluna-propriedades">
              {{ $t('modulos.calibracao.valores.ponto_calibracao') }}
            </th>
            <th v-for="coluna in colunas" :key="`th-${coluna.id}`" scope="rol">
              {{ coluna.cabecalho }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t('modulos.calibracao.valores.sentido') }}</td>
            <td />
            <td v-for="coluna in colunas" :key="`td-${coluna.id}`">
              <v-icon v-if="temSentido(coluna)">
                {{ retornarIconeDirecao(coluna.sentido) }}
              </v-icon>
            </td>
          </tr>
          <tr>
            <td>{{ $t('modulos.calibracao.valores.variavel') }}</td>
            <td />
            <td v-for="coluna in colunas" :key="`td-${coluna.id}`">
              {{ coluna.formulaVariavel?.nome }}
            </td>
          </tr>
        </tbody>
        <tbody class="linhas">
          <tr
            v-for="linha in tabelaValoresAtual.linhas.filter(
              (l) => l.calibracaoFaixaId == tabelaSelecionada.faixaId
            )"
            :key="`tr-${linha.id}${linha.pontoCalibracao.id}`"
          >
            <td>
              <dropdown-padrao text color="secondary">
                <template #botao>
                  <v-icon> $dotsVertical </v-icon>
                </template>
                <dropdown-padrao-item @click="depurarLinha(linha)">
                  {{ $t('modulos.calibracao.valores.botoes.depurar') }}
                </dropdown-padrao-item>
              </dropdown-padrao>
            </td>
            <td
              :class="
                !validarEstePonto(linha.pontoCalibracao.valor)
                  ? 'red--text'
                  : ''
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-if="!validarEstePonto(linha.pontoCalibracao.valor)">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      $alertCircleOutline
                    </v-icon>
                  </span>
                </template>
                <span>{{
                  $t('modulos.calibracao.valores.ponto_invalido')
                }}</span>
              </v-tooltip>
              <div>
                {{ linha.pontoCalibracao.valor | formatarNumeroComPrecisao }} -
                {{ linha.pontoCalibracao?.unidadeMedida?.nome }}
              </div>
              <!-- <div v-if="tabelaValoresAtual.linhas.length > 1">
                {{ linha.pontoCalibracao.valor | formatarNumeroComPrecisao }} -
                {{ linha.pontoCalibracao?.unidadeMedida?.nome }}
              </div>
              <div v-else>
                {{ $t('modulos.calibracao.valores.unico') }}
              </div> -->
            </td>
            <td v-for="coluna in colunas" :key="`th-${coluna.id}`">
              <template v-if="ehLoading(coluna)">
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span>
                        <v-progress-circular
                          v-if="linha.calculando"
                          indeterminate
                          color="primary"
                          :size="20"
                          :width="4"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </span>
                    </template>
                    <span>{{
                      $t('modulos.calibracao.valores.calculando')
                    }}</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-if="ehResultado(coluna)">
                <div v-if="(!temSMC && !temSMP) || visualizar">
                  {{
                    {
                      valor: buscarResultadoAuxiliar(linha, coluna.id),
                      sistema: coluna.unidadeMedidaVariavel?.sistema,
                      formula: coluna.formula?.nome,
                    } | formatarResultado
                  }}
                </div>
                <div v-else>
                  {{
                    {
                      valor: buscarResultado(linha, coluna.id),
                      sistema: coluna.unidadeMedidaVariavel?.sistema,
                      formula: coluna.formula?.nome,
                    } | formatarResultado
                  }}
                </div>
              </template>
              <template v-if="ehTabelaAuxiliar(coluna)">
                {{ buscarTabelaAuxiliar(linha, coluna.id) }}
              </template>
              <template v-if="temTexto(coluna)">
                <div>{{ linha[coluna.indiceTexto] }}</div>
              </template>
              <template v-if="temUnidade(coluna)">
                <div>Unidade</div>
              </template>
              <template v-if="temSentido(coluna)">
                <div style="width: 150px" class="my-2">
                  <!-- DEBUG VALORES  -->
                  <!-- <div class="d-flex align-center mb-2">
                    <icone-padrao
                      :icone="$vuetify.icons.values.eye"
                      cor="danger"
                      tooltip="-"
                    >
                      <template #default>
                        <pre>
                          {{ buscarValor(linha, coluna.id) }}
                        </pre>
                      </template>
                    </icone-padrao>
                    <div class="ml-2">
                      {{ buscarValor(linha, coluna.id).indiceTabulacao }}
                    </div>
                  </div> -->
                  <input-calibracao
                    :ref="`inputOrdem${
                      buscarValor(linha, coluna.id, true).indiceTabulacao
                    }`"
                    v-model="buscarValor(linha, coluna.id).valor"
                    :prevent-tab="
                      buscarValor(linha, coluna.id).indiceTabulacao != undefined
                    "
                    class="flex-fill input-tabela"
                    :class="{ 'disabled-visualizar': visualizar }"
                    :readonly="!temInstrumentoPadrao || visualizar"
                    :sistema="coluna.unidadeMedidaVariavel?.sistema"
                    :disabled="bloquearCampos || !temInstrumentoPadrao"
                    @focus="mostrarInstrumentoPadrao(linha, coluna.id)"
                    @tab="tabularInput(linha, coluna.id)"
                    @shit-tab="tabularInput(linha, coluna.id, true)"
                    @blur="calcularLinha(linha)"
                  />
                </div>
              </template>
              <template v-if="temRefencia(coluna)">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on">
                      {{ linha.referencia?.valor }}
                    </v-btn>
                  </template>
                  <span>
                    Pontos:
                    {{
                      linha.referencia?.melhorCombinacao | formataNumeroPontos
                    }}
                    <hr />
                    Residuo:
                    {{ linha.referencia?.residuo | formatarNumeroComPrecisao }}
                  </span>
                </v-tooltip>
              </template>
              <template v-if="temDescricao(coluna)">
                <input-calibracao
                  v-model="linha.descricao"
                  sistema="Sexagesimal"
                  nao-aplicar-mascara
                  style="width: 150px"
                  background-color="transparent"
                  class="flex-fill input-tabela"
                  selecionar-texto-on-focus
                  prevent-tab
                  :disabled="bloquearCampos || visualizar"
                />
              </template>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-form>
    <modal-padrao
      ref="modal-corpo-email"
      max-width="80%"
      :titulo="'Dados importação'"
      titulo-cancelar="Fechar"
      :mostra-botao-salvar="false"
    >
      <valores-calibracao
        :calibracao-id="calibracaoId"
        :calibracao-faixa-id="faixaId"
      />
    </modal-padrao>

    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao outlined color="secondary" class="mr-2" @click="cancelar">
        <v-icon class="mr-2"> $mdiCancel </v-icon>
        {{ $t('geral.botoes.cancelar') }}
      </botao-padrao>
      <botao-padrao
        v-if="podeEditar"
        class="mr-2"
        :disabled="!alterado"
        @click="calcularLinhasTabela"
      >
        <v-icon class="mr-2"> $mdiContentSaveOutline </v-icon>
        {{ $t('geral.botoes.salvar') }}
      </botao-padrao>
      <botao-padrao v-if="podeEditar" @click="calcularLinhasTabelaFinalizar">
        {{ $t('modulos.calibracao.valores.botoes.finalizar') }}
      </botao-padrao>
    </div>
    <modal-instrumento-padrao
      ref="modalInstrumento"
      :valores="tabelaValoresAtual"
      :instrumento-id="instrumentoId"
      :tabela-selecionada="tabelaSelecionada"
      @salvar-tabela="salvarInstrumentosPadroes"
    />
    <modal-depuracao
      ref="modalDepuracao"
      :tipo-calibracao-id="tipoCalibracaoId"
      :opcoes="opcoes"
    />
    <OCR
      ref="ocr"
      @atualizar-status-ocr="atualizarStatusOCR"
      @texto-reconhecido="calcularLinhas()"
    />
    <CloudVision
      ref="cloudVision"
      @texto-reconhecido="calcularLinhas()"
      @atualizar-status-ocr="atualizarStatusCloudVision"
    />
    <linhas-com-erro-calculo-modal ref="modal-linhas-erros" />
    <portal-serial-modal
      v-if="temComunicacaoInstrumento"
      ref="modal-porta-serial"
      @porta-serial="inserirValorPortaSerial"
    />
    <modal-anexos ref="modalAnexo" />
  </div>
</template>
<script>
import { CalibracaoTabelaModel } from '@common/models/cadastros/CalibracaoTabelaModel';
import ComunicacaoInstrumentoService from '@common/services/cadastros/ComunicacaoInstrumentoService';
import CalibracaoService from '@common/services/cadastros/CalibracaoService';
import helpers from '@common/utils/helpers';
import { InputCalibracao } from '@components/inputs';
import { SentidoConst } from '@const/SentidoConst';
import { TipoColunaConst } from '@const/TipoColunaConst';
import _ from 'lodash';
import CloudVision from './CloudVision.vue';
import { MetodosBuscar, MetodosConfirmacao, MetodosSalvar } from './mixins';
import LinhasComErroCalculoModal from './modais/LinhasComErroCalculoModal.vue';
import PortalSerialModal from './modais/PortalSerialModal.vue';
import ImportacaoDados from './modais/ImportacaoDados.vue';
import ValoresCalibracao from './valoresCalibracao';
import ModalAnexos from './ModalAnexos';
import ModalDepuracao from './ModalDepuracao';
import ModalInstrumentoPadrao from './ModalInstrumentoPadrao';
import OCR from './OCR';

export default {
  components: {
    ModalInstrumentoPadrao,
    LinhasComErroCalculoModal,
    ModalDepuracao,
    OCR,
    InputCalibracao,
    PortalSerialModal,
    CloudVision,
    ImportacaoDados,
    ValoresCalibracao,
    ModalAnexos,
  },
  filters: {
    formatarResultado: function (v) {
      if (v.valor === '' || v.valor === null) return '';
      if (
        v.sistema != 'Sexagesimal' ||
        v.formula == 'veff' ||
        v.formula == 'fatork' ||
        v.formula == 'grausLiberdade'
      )
        return helpers.formatarNumeroComPrecisao(v.valor, true);
      return helpers.decimalParaAngulo(v.valor);
    },
    formataNumeroPontos: function (pontos) {
      if (!pontos || pontos.length == 0) return '';
      return `[ ${pontos
        .map((p) => p.toString().replace('.', ','))
        .join(' | ')} ]`;
    },
  },
  mixins: [MetodosSalvar, MetodosBuscar, MetodosConfirmacao],
  props: [
    'calibracaoId',
    'tabelaSelecionada',
    'instrumentoId',
    'ultimaCalibracaoId',
    'ordemServicoId',
    'utilizaOcr',
    'podeCalibrar',
    'tabelasParaLinhasErro',
    'opcoesTabelas',
    'tipoCalibracaoId',
    'opcoes',
    'faixaId',
    'faixasTabelas',
    'visualizar',
    'ehAgendamento',
  ],
  data() {
    return {
      listaValores: [],
      instrumentoSelecionado: null,
      pontosInvalidos: [],
      statusOCR: false,
      statusCloudVision: false,
      linhasCalculadas: [],
      watchs: {
        tabelaSelecionada: null,
      },
      alterado: false,
      // pontosSemInstrumento: [],
      bloquearCampos: false,
      keyTabelaValores: 0,
      tabelaAuxiliar: [],
      temComunicacaoInstrumento: false,
      port: null,
      reader: null,
      controller_aborter: new AbortController(),
      dadosComunicacaoInstrumento: {},
      listaValoresAuxiliar: [],
      carregandoLinhas: false,
      calibracaoCarregada: false,
    };
  },
  computed: {
    groupedEnsaioDados() {
      const grouped = this.ensaioDados.reduce((acc, item) => {
        if (!acc[item.canal]) {
          acc[item.canal] = {};
        }
        if (!acc[item.canal][item.sequencia]) {
          acc[item.canal][item.sequencia] = [];
        }
        acc[item.canal][item.sequencia].push(item);
        return acc;
      }, {});

      const orderedGrouped = {};
      Object.keys(grouped)
        .sort()
        .forEach((key) => {
          orderedGrouped[key] = grouped[key];
        });

      return orderedGrouped;
    },
    flagImportacaoDados() {
      return !(
        this.tabelasParaLinhasErro &&
        this.tabelasParaLinhasErro[0] &&
        this.tabelasParaLinhasErro[0].procedimentoEletronico &&
        this.tabelasParaLinhasErro[0].procedimentoEletronico.flagImportacaoDados
      );
    },
    instrumentoPadraoAtual: function () {
      if (
        Array.isArray(this.instrumentoSelecionado) &&
        this.instrumentoSelecionado.length
      ) {
        return this.instrumentoSelecionado
          .map((instrumento) => {
            if (!instrumento.instrumento) return;
            let faixa = instrumento.faixa;
            let formatarFaixa = `(${helpers.formatarNumeroComPrecisao(
              faixa.amplitudeMinima
            )} a ${helpers.formatarNumeroComPrecisao(faixa.amplitudeMaxima)}) ${
              faixa.unidadeMedida.nome
            } ; ${faixa.resolucao}`;
            return `${instrumento.instrumento.codigoTag} - ${formatarFaixa}`;
          })
          .join(' | ');
      } else if (
        this.instrumentoSelecionado &&
        this.instrumentoSelecionado.instrumento
      ) {
        let faixa = this.instrumentoSelecionado.faixa;
        let formatarFaixa = `(${helpers.formatarNumeroComPrecisao(
          faixa.amplitudeMinima
        )} a ${helpers.formatarNumeroComPrecisao(faixa.amplitudeMaxima)}) ${
          faixa.unidadeMedida.nome
        } ; ${faixa.resolucao}`;
        return `${this.instrumentoSelecionado.instrumento.codigoTag} - ${formatarFaixa}`;
      } else {
        return '';
      }
    },
    tooltipComunicacaoInstrumento: function () {
      if (
        this.temComunicacaoInstrumento &&
        Array.isArray(this.instrumentoSelecionado) &&
        this.instrumentoSelecionado.length > 1
      ) {
        return this.$t(
          'modulos.calibracao.valores.botoes.tooltip.porta_serial_mais_de_um_padrao'
        );
      } else {
        return this.$t(
          'modulos.calibracao.valores.botoes.tooltip.porta_serial'
        );
      }
    },
    tabelaValoresAtual: function () {
      let tabelaAtual = this.listaValores.find(
        (el) => el.tabelaId == this.tabelaSelecionada?.tabelaId
      );
      if (!tabelaAtual) return new CalibracaoTabelaModel({});
      return tabelaAtual;
    },
    temInstrumentoPadrao: function () {
      let instrumentosTabelaSelecionada = this.tabelaValoresAtual.instrumentosPadroes.filter(
        (ip) =>
          ip.instrumentoCalibracaoFaixa?.id == this.tabelaSelecionada.faixaId
          && ip.tabelaId == this.tabelaSelecionada.tabelaId
      );

      return !instrumentosTabelaSelecionada.some(item => item.instrumento == null)
    },

    desabilitarDepuracao: function () {
      let desabilita = this.tabelaValoresAtual.linhas.filter((linha) => {
        return linha.valores.every((el) => el.valor !== '' && el.valor != null);
      });

      return desabilita.length === 0;
    },
    podeEditar: function () {
      return this.$route.name != 'calibracao-visualizar' && this.podeCalibrar;
    },
    colunas: function () {
      let colunas = [];
      let indiceTexto = 1;
      let tipo = '';
      this.tabelaValoresAtual.colunas.forEach((coluna) => {
        if (
          coluna.tipoColuna == TipoColunaConst.RESULTADO &&
          tipo != TipoColunaConst.RESULTADO
        ) {
          const existeLoad = colunas.some((col) => col.id === 'load');
          if (!existeLoad) {
            colunas.push({
              id: 'load',
              cabecalho: '',
              tipoColuna: TipoColunaConst.LOADING,
            });
          }
        }
        tipo = coluna.tipoColuna;
        if (coluna.tipoColuna == TipoColunaConst.TEXTO) {
          coluna.indiceTexto = `valorTexto${indiceTexto}`;
          indiceTexto++;
        }
        colunas.push(coluna);
      });
      return colunas;
    },
    temSMC: function () {
      return (
        this.tabelaValoresAtual.colunas.filter(
          (el) => el.tipoColuna == TipoColunaConst.SMC
        ).length > 0
      );
    },
    temSMP: function () {
      return (
        this.tabelaValoresAtual.colunas.filter(
          (el) => el.tipoColuna == TipoColunaConst.SMP
        ).length > 0
      );
    },
  },
  watch: {
    mostrarInstrumentoPadrao: function () {
      console.log("watch mostrarInstrumentoPadrao")

      this.$refs.modalInstrumento.abrirModal();
    },
    tabelaSelecionada: function () {
      if (!this.visualizar)
        setTimeout(this.verificarInstrumentoPadraoVazio, 200);
    }
  },
  methods: {
    exibirImportacao() {
      this.$refs['modal-corpo-email'].abrirModal();
    },
    inicializarTela: async function () {
      if (!this.calibracaoCarregada) {
        await this.buscarListaTabelasCalibracao();
        await this.valoresTabelaAuxiliar();
        await this.validarInstrumentos();
        this.calibracaoCarregada = true;
      }

      if (this.watchs.tabelaSelecionada) this.watchs.tabelaSelecionada();

      this.watchs.tabelaSelecionada = this.$watch(
        'tabelaSelecionada',
        async function (velho, novo) {
          if (velho.tabelaId == novo.tabelaId && novo.tabelaId != undefined) {
            setTimeout(() => this.focarPrimeiroCampoVazio(), 200);
            if (!this.visualizar)
              setTimeout(this.verificarInstrumentoPadraoVazio, 200);
            return;
          }
          if (novo == {} || novo == null);

          await this.validarInstrumentos();
          await this.valoresTabelaAuxiliar();

          setTimeout(() => this.focarPrimeiroCampoVazio(), 200);
        }
      );
      console.log("inicializarTela")
      if (!this.visualizar)
        setTimeout(this.verificarInstrumentoPadraoVazio, 200);

      setTimeout(async () => {
        if (!this.visualizar && this.temInstrumentoPadrao) {
          await this.chamarRedis();
        }
      }, 200);
    },
    verificarInstrumentoPadraoVazio() {
      !this.temInstrumentoPadrao &&
        this.$refs.modalInstrumento?.abrirModalPersistente();
    },
    deveDesabilitarDepuracao(linha) {
      const todosValoresPreenchidos = linha.valores.every(
        (linha) => linha.valor
      );
      return todosValoresPreenchidos;
    },
    // verficarPontosSemInstrumentos: function () {
    //   this.pontosSemInstrumento =
    //     this.tabelaValoresAtual.instrumentosPadroes.filter(
    //       (x) => !x.instrumento
    //     );
    // },
    conectar() {
      if (this.port) {
        this.fecharConexao();
      }

      this.abrirPorta().then(() => {
        this.toastSucesso('Conectado com sucesso!');
        this.iniciarLeitura();
      });
    },
    fecharPorta() {
      this.port?.close().then(() => {
        setTimeout(
          () => this.toastAlerta('Conexão com o instrumento encerrada!'),
          500
        );
        this.port = null;
      });
    },
    async iniciarLeitura() {
      const decoder = new window.TextDecoderStream();
      this.controller_aborter = new AbortController();
      this.port.readable
        .pipeTo(decoder.writable, { signal: this.controller_aborter.signal })
        .catch(() => {
          this.controller_aborter.signal.aborted && this.fecharPorta();
        });
      const inputStream = decoder.readable;
      this.reader = inputStream.getReader();
      try {
        //eslint-disable-next-line
        while (true) {
          const { value, done } = await this.reader.read();
          if (done) window.alert('A leitura do equipamento foi encerrada!');
          if (done) break;

          if (value.length == 1 && value != '0') continue;

          this.$emit('porta-serial', value);
        }
      } catch (error) {
        console.warn(error);
        this.reader.releaseLock();
        this.reader = null;
        !this.controller_aborter.signal.aborted &&
          setTimeout(this.iniciarLeitura, 100);
      }
    },
    async abrirPorta() {
      if (this.port) return;
      const port = await navigator.serial.requestPort();

      await port.open({
        baudRate: Number(this.dadosComunicacaoInstrumento.baudRate),
        dataBits: Number(this.dadosComunicacaoInstrumento.dataBits),
        parity: this.dadosComunicacaoInstrumento.parity,
        stopBits: Number(this.dadosComunicacaoInstrumento.stopBits),
      });

      this.port = port;
      return;
    },
    fecharConexao() {
      this.controller_aborter.abort();
    },
    foiAlterado: function () {
      return this.alterado;
    },
    iniciarCapturaOCR: function () {
      this.$refs.ocr.iniciarCompartilhamento();
    },
    interrromperCapturaOCR: function () {
      this.$refs.ocr.finalizarCompartilhamento();
    },
    atualizarStatusOCR: function (statusOCR) {
      this.statusOCR = statusOCR;
    },
    iniciarCapturaCloudVision: function () {
      this.$refs.cloudVision.iniciarCompartilhamento();
    },
    interrromperCapturaCloudVision: function () {
      this.$refs.cloudVision.finalizarCompartilhamento();
    },
    atualizarStatusCloudVision: function (statusCloudVision) {
      this.statusCloudVision = statusCloudVision;
    },
    abrirParaConversorDeUnidadeDeMedida: function () {
      window.open(
        this.$router.resolve({ name: 'conversor-unidade' }).href,
        '_blank'
      );
    },
    abrirEdicaoDoInstrumento: function () {
      window.open(
        this.$router.resolve({
          name: 'instrumento-editar',
          params: { id: this.instrumentoId },
        }).href,
        '_blank'
      );
    },
    abrirVisualizarDadosHistorico: function () {
      window.open(
        this.$router.resolve({
          name: 'calibracao-visualizar',
          params: {
            calibracaoId: this.ultimaCalibracaoId,
          },
        }).href,
        '_blank'
      );
    },

    limparColuna: function (tipoColuna) {
      this.tabelaValoresAtual.linhas.forEach((linha) => {
        linha.valores = linha.valores.map((colunaValor) => {
          if (colunaValor.tipoColuna == tipoColuna) colunaValor.valor = '';
          return colunaValor;
        });
        linha.resultados = [];
        this.keyTabelaValores++;
        this.calcularLinha(linha);
      });
    },
    copiarColuna: function (tipoColuna) {
      this.tabelaValoresAtual.linhas.forEach((linha) => {
        if (linha.calibracaoFaixaId != this.tabelaSelecionada.faixaId) return;

        let valorAnterior = linha.pontoCalibracao.valor;
        linha.valores = linha.valores.map((colunaValor) => {
          if (colunaValor.tipoColuna == tipoColuna) {
            if (colunaValor.valor != '' && colunaValor.valor != null)
              valorAnterior = colunaValor.valor;
            colunaValor.valor = valorAnterior;
          }
          return colunaValor;
        });
        this.keyTabelaValores++;
        this.calcularLinha(linha);
      });
    },
    copiarHistorico: function () {
      this.$store.dispatch('Layout/iniciarCarregamento');
      CalibracaoService.buscarHistorico(
        this.tabelaSelecionada.tabelaId,
        this.instrumentoId
      )
        .then((res) => {
          res.data.forEach((linhaHistorico) => {
            let linha = this.tabelaValoresAtual.linhas.find(
              (linhaValores) =>
                linhaValores.pontoCalibracao.id ==
                  linhaHistorico.instrumentoFaixaPontoId &&
                linhaValores.tabelaLinhaId == linhaHistorico.tabelaLinhaId
            );

            if (linha) {
              linhaHistorico.valores.forEach((valorHistorico) => {
                let coluna = linha.valores.find(
                  (el) => el.tabelaColunaId == valorHistorico.tabelaColunaId
                );
                if (coluna) coluna.valor = valorHistorico.valor;
              });
              this.calcularLinha(linha);
            }
          });
          this.keyTabelaValores++;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscarComunicacaoInstrumento: function () {
      if (!this.instrumentoSelecionado[0]?.instrumento?.id) return;
      this.$store.dispatch('Layout/iniciarCarregamento');
      ComunicacaoInstrumentoService.buscarInstrumentos(
        this.instrumentoSelecionado[0]?.instrumento?.id
      )
        .then((res) => {
          if (res.data) {
            this.temComunicacaoInstrumento = true;
            this.dadosComunicacaoInstrumento = res.data;
          }
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    // abrirModalInstrumentoVazio: function (linha, tabelaColunaId) {
    //   if (this.pontosSemInstrumento.length > 0) {
    //     this.$refs[`inputOrdem1`][0].blur();
    //     if (linha && tabelaColunaId)
    //       this.$refs[
    //         `inputOrdem${
    //           this.buscarValor(linha, tabelaColunaId).indiceTabulacao
    //         }`
    //       ][0].blur();
    //     setTimeout(() => {
    //       this.$refs.modalInstrumento.abrirModalPersistente(
    //         this.pontosSemInstrumento.map((el) => {
    //           return {
    //             variavelId: el.formulaVariavelId,
    //             pontoCalibracaoId: el.pontoCalibracaoId,
    //           };
    //         })
    //       );
    //     }, 500);
    //   }
    // },
    mostrarInstrumentoPadrao: function (linha, tabelaColunaId) {
      let celulaSelecionada = this.buscarValor(linha, tabelaColunaId);
      this.instrumentoSelecionado =
        this.tabelaValoresAtual.instrumentosPadroes.filter(
          (el) =>
            el.pontos.some(
              (ponto) =>
                ponto.calibracaoFaixaPonto.id ===
                celulaSelecionada.pontoCalibracaoId
            ) && el.formulaVariavel.id == celulaSelecionada.formulaVariavelId
        );
    },
    validarInstrumentos: async function () {
      if (!this.tabelaSelecionada.tabelaId || !this.podeEditar) return;
      this.$store.dispatch(
        'Layout/iniciarCarregamento',
        'Validando instrumentos da tabela de calibração'
      );

      await CalibracaoService.validarInstrumentos(
        this.calibracaoId,
        this.tabelaSelecionada.tabelaId
      )
        .then((res) => {
          if (res.data.length == 0) return;

          let mensagem = this.$t(
            'modulos.calibracao.valores.alertas.mensagem_instrumentos'
          );
          res.data.forEach((m) => {
            mensagem += `<br> - ${m.instrumento.nome} - ${this.$t(
              `enums.EnumInstrumentoPadraoValidacao.${m.instrumentoPadraoValidacao}`
            )}`;
          });
          this.mensagemConfirmacao(
            this.$t('geral.titulos.atencao'),
            mensagem,
            this.$t('geral.botoes.ok'),
            true
          );
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    valoresTabelaAuxiliar: async function () {
      if (!this.tabelaSelecionada?.tabelaId) return;
      this.$store.dispatch('Layout/iniciarCarregamento');
      let objetoSelecionado = this.listaValores.find(
        (objeto) => objeto.tabelaId === this.tabelaSelecionada.tabelaId
      );
      let idsLinhas = objetoSelecionado?.linhas.map((linha) => linha.id);

      await CalibracaoService.valoresTabelaAuxiliar(
        this.calibracaoId,
        idsLinhas
      )
        .then((res) => {
          this.tabelaAuxiliar = res.data;
          this.listaValoresAuxiliar = res.data.valores;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscarTabelaAuxiliar: function (linha, colunaId) {
      const linhaAuxiliar = this.tabelaAuxiliar.find(
        (el) => el.calibracaoLinhaId == linha.id
      );

      return linhaAuxiliar?.valores?.find((el) => el.tabelaColunaId == colunaId)
        .valor;
    },
    validarPontos: function () {
      CalibracaoService.validarPontos(
        this.calibracaoId,
        this.tabelaSelecionada.tabelaId
      ).then((res) => {
        if (!res.data.isValid)
          this.toastErro(
            this.$t('modulos.calibracao.valores.pontos_invalidos')
          );

        this.pontosInvalidos = res.data.pontosForaFaixa;
      });
    },
    validarEstePonto: function (ponto) {
      return !this.pontosInvalidos.includes(ponto);
    },
    retornarIconeDirecao: function (direcao) {
      switch (direcao) {
        case SentidoConst.DeBaixoParaCima:
          return '$arrowUp';
        case SentidoConst.DeCimaParaBaixo:
          return '$arrowDown';
        case SentidoConst.DaEsquerdaParaDireita:
          return '$arrowRight';
        case SentidoConst.DeCimaParaBaixoProximaTabela:
          return '$cimaProxima';
        case SentidoConst.DeBaixoParaCimaProximaTabela:
          return '$baixoProxima';
      }
    },

    temSentido: function (coluna) {
      return (
        coluna.tipoColuna == TipoColunaConst.SMC ||
        coluna.tipoColuna == TipoColunaConst.SMP
      );
    },
    temRefencia: function (coluna) {
      return coluna.tipoColuna == TipoColunaConst.REFERENCIA;
    },
    ehLoading: function (coluna) {
      return coluna.tipoColuna == TipoColunaConst.LOADING;
    },
    ehResultado: function (coluna) {
      return coluna.tipoColuna == TipoColunaConst.RESULTADO;
    },
    ehTabelaAuxiliar: function (coluna) {
      return coluna.tipoColuna == TipoColunaConst.TABELAAUXILIAR;
    },
    temUnidade: function (coluna) {
      return coluna.tipoColuna == TipoColunaConst.UNIDADE;
    },
    temTexto: function (coluna) {
      return (
        coluna.tipoColuna == TipoColunaConst.TEXTO ||
        coluna.tipoColuna == TipoColunaConst.REFERENCIA
      );
    },
    temDescricao: function (coluna) {
      return coluna.tipoColuna == TipoColunaConst.DESCRICAO;
    },
    buscarValor: function (linha, tabelaColunaId) {
      const valor = linha.valores.find(
        (valor) => valor.tabelaColunaId == tabelaColunaId
      );
      return valor;
    },
    tabularInput: async function (linha, colunaId, shift = false) {
      let input = this.buscarValor(linha, colunaId);

      if (input.indiceTabulacao == undefined) return;
      if (this.statusOCR)
        this.$refs.ocr.reconhecerTexto(
          this.$refs[`inputOrdem${input.indiceTabulacao}`][0],
          input
        );

      if (this.statusCloudVision) {
        const reconhecerTextoGoogle = this.$refs.cloudVision.reconhecerTexto(
          this.$refs[`inputOrdem${input.indiceTabulacao}`][0],
          input
        );

        reconhecerTextoGoogle.then(() => {
          this.interrromperCapturaCloudVision();
          this.iniciarCapturaCloudVision();
        });
      }

      if (input.ultimo && !input.proximaTabela && !shift) {
        this.$refs[`inputOrdem${input.indiceTabulacao}`][0].blur();
        setTimeout(() => {
          this.$refs[`inputOrdem${input.indiceTabulacao}`][0].focus();
        }, 200);

        if (linha.resultados.length > 0) {
          this.confirmacaoIrProximaTabela();
        }
        return;
      }
      if (input.proximaTabela && !shift && this.opcoesTabelas.length > 0) {
        this.$refs[`inputOrdem${input.indiceTabulacao}`][0].blur();
        setTimeout(() => {
          this.$emit('proxima-tabela');
          this.focarPrimeiroCampoVazio();
        }, 200);
        return;
      }

      if (input.voltarTabela && !shift && this.opcoesTabelas.length > 0) {
        this.$refs[`inputOrdem${input.indiceTabulacao}`][0].blur();
        setTimeout(() => {
          this.$emit('tabela-anterior');
          this.focarPrimeiroCampoVazio();
        }, 200);
        return;
      }

      if (shift && input.indiceTabulacao == 1) return;
      this.$refs[
        `inputOrdem${input.indiceTabulacao + (!shift ? 1 : -1)}`
      ][0].focus();
    },
    focarPrimeiroCampoVazio: function () {
      setTimeout(() => {
        let indice = 1;
        let achou = false;
        while (this.$refs[`inputOrdem${indice}`] !== undefined) {
          if (!this.$refs[`inputOrdem${indice}`][0].value) {
            achou = true;
            break;
          }
          indice++;
        }
        if (achou) {
          this.$refs[`inputOrdem${indice}`][0].focus();
        } else {
          this.$refs[`inputOrdem${indice - 1}`][0].focus();
        }
      }, 400);
    },
    calcularLinhas: async function () {
      if (this.visualizar) return;

      const linhasParaCalcular = this.tabelaValoresAtual.linhas.filter(
        (linha) => {
          return linha.valores.every(
            (el) => el.valor != '' && el.valor != null
          );
        }
      );

      const promises = linhasParaCalcular.map((linha) =>
        this.calcularLinha(linha)
      );

      await Promise.all(promises);

      await this.confirmacaoSalvar();
    },
    calcularLinhasFinalizar: async function () {
      if (this.visualizar) return;

      const linhasParaCalcular = this.tabelaValoresAtual.linhas.filter(
        (linha) => {
          return linha.valores.every(
            (el) => el.valor != '' && el.valor != null
          );
        }
      );

      const promises = linhasParaCalcular.map((linha) =>
        this.calcularLinha(linha)
      );

      await Promise.all(promises);

      await this.confirmarFinalizarCalibracao();
    },
    calcularLinha: function (linha) {
      return new Promise((resolve, reject) => {
        if (this.visualizar) return resolve();

        let valoresFiltrados = linha.valores.filter(
          (el) =>
            el.tipoColuna == TipoColunaConst.SMC ||
            el.tipoColuna == TipoColunaConst.SMP
        );

        let linhaCalculada = this.linhasCalculadas.find(
          (el) => el.linhaId == linha.id
        );
        let valido = !linhaCalculada;
        if (linhaCalculada) {
          valoresFiltrados.forEach((el) => {
            if (
              !linhaCalculada.valores.find(
                (l) =>
                  l.tabelaColunaId == el.tabelaColunaId && l.valor === el.valor
              )
            ) {
              valido = true;
              return;
            }
          });
        }

        if (valido) this.alterado = true;

        linhaCalculada.valores = valoresFiltrados.map((el) => {
          return {
            tabelaColunaId: el.tabelaColunaId,
            valor: _.cloneDeep(el.valor),
          };
        });

        if (
          !valoresFiltrados.every((el) => el.valor !== '' && el.valor !== null)
        ) {
          linha.resultados = [];
          return resolve();
        }

        linha.resultados = [];
        linha.calculando = true;
        this.carregandoLinhas = linha.calculando;
        this.$forceUpdate();

        CalibracaoService.calcularLinha(this.calibracaoId, linha.id, linha)
          .then((res) => {
            linha.resultados = res.data.valores;
          })
          .finally(() => {
            linha.calculando = false;
            this.carregandoLinhas = linha.calculando;
            this.$forceUpdate();
            resolve();
          })
          .catch((error) => {
            console.error('Erro ao calcular linha:', error);
            reject(error);
          });
      });
    },
    depurarLinha: function (linha) {
      this.$refs['modalDepuracao'].abrirModal(this.calibracaoId, linha);
    },
    builderResultado: function (linha, id, v) {
      let resultado = this.buscarResultado(linha, id);
      let temValor =
        resultado === '0' || resultado === '' ? false : Boolean(resultado);

      if (!temValor) {
        const resultado = linha.valores.find(
          (valor) => valor.tabelaColunaId == id
        );
        return resultado.valor == 0
          ? resultado.valorTexto
          : resultado.valorTexto;
      }

      if (v.valor === '' || v.valor === null) return '';

      if (
        v.sistema != 'Sexagesimal' ||
        v.formula == 'veff' ||
        v.formula == 'fatork' ||
        v.formula == 'grausLiberdade'
      )
        return helpers.formatarNumeroComPrecisao(v.valor, true);
      return helpers.decimalParaAngulo(v.valor);
    },
    buscarResultadoAuxiliar: function (linha, colunaId) {
      let resultado = this.tabelaAuxiliar
        .find((el) => el.calibracaoLinhaId == linha.id)
        ?.valores?.find((el) => el.tabelaColunaId == colunaId).valor;
      console.log("buscarResultadoAuxiliar: ", resultado);
      if (resultado === undefined || resultado === null) return '';
      return String(resultado).replace('.', ',');
    },
    buscarResultado: function (linha, colunaId) {
      let resultado = linha.resultados.find((el) => el.id == colunaId)?.valor;
      console.log("buscarResultado: ", resultado);
      if (resultado === undefined || resultado === null) return '';
      return String(resultado).replace('.', ',');
    },
    cancelar: function () {
      this.confirmarCancelar().then(() => {
        this.$router.push({
          name: this.$route.query?.retorno || (this.ehAgendamento ? 'agendamento' : 'operacao'),
          params: { id: this.$route.query?.instrumentoRetorno || null },
        });
      });
    },

    inserirValorPortaSerial: function (valor) {
      setTimeout(() => {
        let indice = 1;
        let achou = false;
        while (this.$refs[`inputOrdem${indice}`] !== undefined) {
          if (!this.$refs[`inputOrdem${indice}`][0].value) {
            achou = true;
            break;
          }
          indice++;
        }
        if (achou) {
          this.$refs[`inputOrdem${indice}`][0].focus();
          this.$refs[`inputOrdem${indice}`][0].alterarValor(valor);
          this.$refs[`inputOrdem${indice}`][0].onEnter();
        } else {
          this.$refs[`inputOrdem${indice - 1}`][0]?.focus();
          this.$refs[`inputOrdem${indice - 1}`][0]?.alterarValor(valor);
          this.$refs[`inputOrdem${indice - 1}`][0]?.onEnter();
        }
      }, 100);
    },
    anexarArquivo: function () {
      this.$refs['modalAnexo'].abrirModal(
        this.calibracaoId,
        this.faixasTabelas
      );
    },
  },
};
</script>
<style lang="scss">
.coluna-select {
  width: 200px;
  font-weight: 400;
}
.tabela-dinamica-calibracao {
  th {
    background-color: $color-primary-grey-100;
  }
  .coluna-propriedades {
    width: 0;
  }
  .linhas tr:first-child td {
    border-top: 2px solid;
  }
}

.disabled-visualizar {
  color: rgba(0, 0, 0, 0.38);
  background-color: #f5f5f5;
  pointer-events: none;
  opacity: 0.6;
}
</style>
